import { isObject } from ".";

export const titleCase = (text: string): string => {
  const transformed = text.toLowerCase().split(" ");
  for (let i = 0; i < transformed.length; i++) {
    transformed[i] =
      transformed[i].charAt(0).toUpperCase() + transformed[i].slice(1);
  }
  return transformed.join(" ");
};

export const snakeCase = (text = ""): string =>
  text.toLowerCase().replace(/ /g, "_");

export const toPascalCase = (text = ""): string =>
  text
    .replace(/[_\-\s]+/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join("");

export const camelToTitleCase = (text: string): string => {
  const withSpaces = text.replace(/([A-Z])/g, " $1").toLowerCase();
  const titleCased = titleCase(withSpaces);
  return titleCased;
};

// Convert camelCase to snake_case, but ignore
// any letters that follow square brackets
// THIS VERSION USES LOOKBEHINDS, WHICH ARE NOT SUPPORTED IN SAFARI
// export const camelToSnakeCase = (text: string) =>
//   text.charAt(0).toLowerCase() +
//   text.slice(1).replace(/(?<!\[)[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const camelToSnakeCase = (text: string) =>
  text.charAt(0).toLowerCase() +
  text
    .slice(1)
    .replace(/(\[.*?\])|[A-Z]/g, (match, group) =>
      group ? match : `_${match.toLowerCase()}`,
    );

// Deeply converts keys in an object to snake_case
export const snakeCaseKeys = (object: Record<string, unknown>) =>
  Object.entries(object || {}).reduce(
    (acc: Record<string, unknown>, [key, value]): Record<string, unknown> => {
      const newKey = camelToSnakeCase(key);

      if (Array.isArray(value) && value.every(isObject)) {
        return {
          ...acc,
          [newKey]: value.map(v => snakeCaseKeys(v)),
        };
      }

      if (isObject(value)) {
        return {
          ...acc,
          [newKey]: snakeCaseKeys(value),
        };
      }

      return {
        ...acc,
        [newKey]: value,
      };
    },
    {},
  );

export const isNumeric = (str = "") => {
  return !isNaN(Number(str)) && !isNaN(parseFloat(str));
};

export const isCurrency = (string = "") => {
  const number = string.replace(/£/g, "");
  return isNumeric(number);
};

export const spaceDelimitedList = (
  list: (string | null | undefined)[],
): string | undefined => list.filter(Boolean).join(" ") || undefined;

export const containsHtmlMarkup = (text: string): boolean => {
  // list from Rater's HTML validator spec (spec/html_validation_spec.rb) Aug 13th 2025
  const validElements = [
    "strong",
    "b",
    "p",
    "ul",
    "li",
    "ol",
    "i",
    "em",
    "table",
    "tr",
    "td",
    "br", // regex will handle the <br/> and <br /> versions
    "div",
    "a",
    "img",
  ];
  const validElementsPattern = validElements.join("|");
  const htmlTagRegex = new RegExp(`<(${validElementsPattern})\\b[^>]*>`, "i");

  return htmlTagRegex.test(text);
};
